import React, { useState, useRef, useContext } from 'react'

import { Prompt } from 'react-router'

//import _ from 'lodash'

import history from 'history.js'

import { useLocation } from "react-router-dom"

import AppContext from '../../../contexts/AppContext'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import PATH from '../../../business-const/Path/Path'

import AuthService from '../../../business-api/AuthService'

import ClienteService from '../../../business-api/ClienteService'

import {
    nvl,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem2,
    GridItem6,
    GridItem10,
} from '../../../business-components/Grid/Grid'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import formList from '../../../business-rules/List/formList'

import tipoLicencaList from '../../../business-rules/List/Assinatura/tipoLicencaList'

import tabClienteFormList from '../../../business-rules/List/tabClienteFormList'

import perfilList from '../../../business-rules/List/perfilList'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    FormikPadrao,
} from '../../../business-components/Form/Form'

import {
    DivFormN0,
    DivFormN1,
    DivForm,
} from '../../../business-components/Div/Div'

import BreadcrumbPadrao from '../../../business-components/Breadcrumb/Breadcrumb'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import {
    ButtonReinicializarCenarios,
    ButtonReordenarCenarios,
} from '../../../business-components/Button/Button'

import {
    IconButtonConfiguracaoCliente,
    IconButtonMoveParaCimaParaBaixo,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    CircularProgressPadrao,
} from '../../../business-components/CircularProgress/CircularProgress'

import {
    getConfiguracaoUsuario,
    getEquipeList,
    identificaIndexIdWhiteLabel,
} from '../../configuracao/ConfiguracaoService'

import {
    calculaComparacaoEstudos,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    getArquivoList,
} from '../../arquivo/ArquivoService'

import {
    reinicializarCenarios,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    objetoCliente,
    comparaCliente,
    getByIdClienteExemploMandatorio,
    inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient,
    inicializaControleVersao,
    getInfoclient,
    obtemJsonClienteAlteracao,
    putClienteInfoclient,
    dadosCompletosCliente,
} from './ClienteService'


import ClienteFormCliente from './ClienteFormCliente'

import CaptacaoLeadsForm from '../captacaoLeads-form/CaptacaoLeadsForm'

import FormForm from '../form-form/FormForm'

import CadastroForm from '../cadastro-form/CadastroForm'

import FluxoCaixaForm from '../fluxoCaixa-form/FluxoCaixaForm'

import PatrimonioForm from '../patrimonio-form/PatrimonioForm'

import SimulacaoFinanceiraFormMenu from '../simulacaoFinanceira-form/SimulacaoFinanceiraFormMenu'

import EstudoForm from '../estudo-form/EstudoForm'

import ConsideracoesFinaisForm from '../consideracoesFinais-form/ConsideracoesFinaisForm'

import AcompanhamentoForm from '../acompanhamento-form/AcompanhamentoForm'

//import LogAcessoClienteForm from '../log-form/LogAcessoClienteForm'

import {
    MensagemDadosObrigatoriosClienteDevemSerInformados,
} from './ClienteComp'



const ClienteForm = ({ origem }) => {

    const location = useLocation()

    const [initialValues, setInitialValues] = useState(null)

    const [carregou, setCarregou] = useState(false)

    const [saving, setSaving] = useState(false)

    const [vars, setVars] = useState(
        {
            equipeList: false,
            perfil: false,
            linhaPerfil: false,
            linhaTipoLicenca: false,
            fullWhiteLabel: "N",
            idConfiguracao: false,
            jsonConfiguracao: {}, //false,
            indexIdWhiteLabel: HARDCODE.idWhiteLabelPadrao,
            jsonPagina: false,
            jsonGestaoPatrimonial: false,
            jsonUsuario: false,
            jsonUsuarioAdmin: false,
        }
    )

    const [arquivoList, setArquivoList] = useState([])

    const [linhaFormList, setLinhaFormList] = useState({})
    
    const cliente = useRef(null)

    const valuesAnt = useRef(null)

    const { variaveisGlobais } = useContext(AppContext)

    if (ClienteService.obterClienteSelecionado(variaveisGlobais) === undefined ) {

        history.push(PATH.pageClienteList)
    }

    const idCliente = ClienteService.obterClienteSelecionado(variaveisGlobais)

    const ultimaVersao = ClienteService.obterUltimaVersaoClienteSelecionado(variaveisGlobais)

    const jsonComparacaoEstudos = ClienteService.obterJsonComparacaoEstudosClienteSelecionado(variaveisGlobais)

    const versao = ClienteService.obterVersaoSelecionada(variaveisGlobais)

    const atribuibuiInitialValues = () => {

        if (location.jsonAcessoCliente) {

            cliente.current.jsonAcessoCliente =
                {
                    acessoCliente: true,
                    ...JSON.parse(location.jsonAcessoCliente)
                }

            cliente.current.formulario =
                cliente.current.jsonAcessoCliente.formulario
                    ?
                        cliente.current.jsonAcessoCliente.formulario
                    :
                        cliente.current.formulario

            cliente.current.cenarioAtual = cliente.current.jsonAcessoCliente.cenarioAtual
            cliente.current.descricaoCenario = cliente.current.jsonAcessoCliente.descricaoCenario

            cliente.current.template = cliente.current.jsonAcessoCliente.template
            cliente.current.disposicaoRelatorio = cliente.current.jsonAcessoCliente.disposicaoRelatorio
            cliente.current.reportImprimir = cliente.current.jsonAcessoCliente.reportImprimir
            cliente.current.reportNaoImprimir = cliente.current.jsonAcessoCliente.reportNaoImprimir

            cliente.current.exibirCapacidadePoupancaRelatorio = cliente.current.jsonAcessoCliente.exibirCapacidadePoupancaRelatorio
            cliente.current.exibirAportesRetiradasPlanejadosRelatorio =
                cliente.current.jsonAcessoCliente.exibirAportesRetiradasPlanejadosRelatorio
            cliente.current.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira =
                cliente.current.jsonAcessoCliente.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira
            cliente.current.naoExibirEvolucaoReservaFinanceira =
                cliente.current.jsonAcessoCliente.naoExibirEvolucaoReservaFinanceira
            cliente.current.exibirProtecaoSugeridaRelatorio = cliente.current.jsonAcessoCliente.exibirProtecaoSugeridaRelatorio
            cliente.current.exibirSucessaoVitaliciaRelatorio = cliente.current.jsonAcessoCliente.exibirSucessaoVitaliciaRelatorio
            cliente.current.exibirComparacaoCenariosRelatorio = cliente.current.jsonAcessoCliente.exibirComparacaoCenariosRelatorio
            cliente.current.exibirComparacaoCenariosRelatorioSemTabelaGrafico =
                cliente.current.jsonAcessoCliente.exibirComparacaoCenariosRelatorioSemTabelaGrafico
            cliente.current.exibirComparacaoEstudosRelatorio = cliente.current.jsonAcessoCliente.exibirComparacaoEstudosRelatorio
            cliente.current.exibirConsideracoesFinaisRelatorio = cliente.current.jsonAcessoCliente.exibirConsideracoesFinaisRelatorio
            

            cliente.current.modoInteracaoCliente = true

        } else {

            cliente.current.jsonAcessoCliente = {
                acessoCliente: false,
            }
        }


        valuesAnt.current = JSON.parse(JSON.stringify(cliente.current))//{...cliente.current}


        if (location.integracaoCRM) {

            cliente.current.idClienteIntegracaoCRM = location.integracaoCRM.idClienteIntegracaoCRM
            cliente.current.nomeCliente = location.integracaoCRM.nomeClienteIntegracaoCRM
            cliente.current.cpfCliente = location.integracaoCRM.cpfClienteIntegracaoCRM
        }


        setInitialValues(cliente.current)

        setLinhaFormList(pesquisaList(formList, cliente.current.idFormList))
    }

    const setTabIndexClientePrimeiraReuniaoAprofundamento = ( formListRadioGroup, tabIndexClientePrimeiraReuniao,
        tabIndexClienteAprofundamento, idFormList, linhaTipoLicencaAux, usuarioClienteSelecionadoAtivo, jsonUsuario,
            jsonAcessoCliente ) => {

        const linhaFormListAux = pesquisaList(formList, idFormList)

        if (
                formListRadioGroup === HARDCODE.formListPrimeiraReuniao && 
                (
                    tabIndexClientePrimeiraReuniao || 
                    tabIndexClientePrimeiraReuniao === 0
                )
        ) {

            if (
                    tabClienteFormList(formListRadioGroup, linhaFormListAux, linhaTipoLicencaAux, usuarioClienteSelecionadoAtivo,
                        jsonUsuario, jsonAcessoCliente).length - 1 < tabIndexClientePrimeiraReuniao
            ) {

                tabIndexClientePrimeiraReuniao = 0
            }

            setTabIndexCliente(tabIndexClientePrimeiraReuniao)

        } else {

            if (
                    formListRadioGroup === HARDCODE.formListAprofundamento && 
                    (
                        tabIndexClienteAprofundamento || 
                        tabIndexClienteAprofundamento === 0
                    )
            ) {
                
                if (
                        tabClienteFormList(formListRadioGroup, linhaFormListAux, linhaTipoLicencaAux, usuarioClienteSelecionadoAtivo,
                            jsonUsuario, jsonAcessoCliente).length - 1 < tabIndexClienteAprofundamento
                ) {

                    tabIndexClienteAprofundamento = 0
                }

                setTabIndexCliente(tabIndexClienteAprofundamento)
            }
        }
    }

    async function obterEquipeList (idConfiguracao) {

        const equipeList = await getEquipeList(variaveisGlobais, idConfiguracao, true)

        equipeList?.forEach( (linha, ind) => {

            linha.descricao = linha.nome
        })

        return equipeList
    }

    async function obterArquivoList (values) {

        const arquivoList1 = await getArquivoList(variaveisGlobais, ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
            HARDCODE.idGrupoArquivoClienteIntegracao, null, null, HARDCODE.PDF, HARDCODE.idStatusProcessamentoDadosImportados, null,
                null, values.id, null, null, null, null)

        const arquivoList2 = await getArquivoList(variaveisGlobais, ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
            HARDCODE.idGrupoArquivoClienteHistorico, null, null, null, HARDCODE.idStatusProcessamentoNaoSeAplica, null,
                null, values.id, null, null, null, null)

        setArquivoList([...arquivoList2, ...arquivoList1])
    }

    const calculaFormListRadioGroup = (formListRadioGroup, /*perfil,*/ linhaTipoLicencaAux) => {

        let formListRadioGroupAux = formListRadioGroup

        if (
                //perfil === HARDCODE.perfilAssessor ||
                //pesquisaList(formList, cliente.current.idFormList).exibirCompleto === 'N' ||
                linhaTipoLicencaAux.exibirCompleto === 'N' ||
                AuthService.obterAcessoCliente(variaveisGlobais)
        ) {

            formListRadioGroupAux = HARDCODE.formListPrimeiraReuniao

        } else {

            if (linhaTipoLicencaAux.exibirSimulacaoFinanceira === 'N') {

                formListRadioGroupAux = HARDCODE.formListAprofundamento

            } else {

                if (!formListRadioGroup ) {

                    formListRadioGroupAux = HARDCODE.formListPrimeiraReuniao
                }
            }
        }
    
        return formListRadioGroupAux
    }

    const obterInfoclient = async (idCliente, ultimaVersao, jsonComparacaoEstudos, versao, /*perfil,*/ linhaTipoLicencaAux,
        usuarioClienteSelecionadoAtivo, jsonPagina, jsonUsuario, jsonUsuarioAdmin, jsonInfoclientCopia) => {

        const idFormList = cliente.current.idFormList

        if (jsonInfoclientCopia) {

            cliente.current = jsonInfoclientCopia

            cliente.current.id = null

            //cliente.current.nomeCliente =  (nvl(cliente.current.nomeCliente, '') +
            //    ' (' + (location.clienteExemplo ? LABEL.exemplo : LABEL.copia) + ')').trim()

        } else {

            cliente.current = await getInfoclient(variaveisGlobais, null, idCliente, versao)

            cliente.current.id = idCliente
        }

        cliente.current.idFormList = cliente.current.idFormList ? cliente.current.idFormList : idFormList
        cliente.current.ultimaVersao = ultimaVersao
        cliente.current.jsonComparacaoEstudos = jsonComparacaoEstudos
        cliente.current.versao = versao

        cliente.current.versoesInfoclient = null

        cliente.current = inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient(variaveisGlobais, cliente.current,
            linhaTipoLicencaAux, jsonPagina, jsonUsuario, jsonUsuarioAdmin, jsonInfoclientCopia ? true : false)

        if (cliente.current.jsonComparacaoEstudos.estudos.length === 0) {

            calculaComparacaoEstudos(cliente.current)
        }

        cliente.current.formListRadioGroup =
            calculaFormListRadioGroup(cliente.current.formListRadioGroup, /*perfil,*/ linhaTipoLicencaAux)

        atribuibuiInitialValues()

        if (jsonInfoclientCopia) {

             cliente.current.nomeCliente =  (nvl(cliente.current.nomeCliente, '') +
                ' (' + (location.clienteExemplo ? LABEL.exemplo : LABEL.copia) + ')').trim().toUpperCase()
        }

        setTabIndexClientePrimeiraReuniaoAprofundamento(
            cliente.current.formListRadioGroup,
                cliente.current.tabIndexClientePrimeiraReuniao,
                    cliente.current.tabIndexClienteAprofundamento, cliente.current.idFormList, linhaTipoLicencaAux,
                        usuarioClienteSelecionadoAtivo, jsonUsuario, cliente.current.jsonAcessoCliente
        )

        if (!jsonInfoclientCopia) {
        
            await obterArquivoList (cliente.current)
        }

        setCarregou(true)
    }
    
    useSingleton(async () => {

        cliente.current = {}

        let { perfil, tipoLicenca, fullWhiteLabel, ativo, idConfiguracao, idFormList, jsonConfiguracao, jsonPagina,
            jsonGestaoPatrimonial, jsonUsuario, jsonUsuarioAdmin } = await getConfiguracaoUsuario(variaveisGlobais,
                ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais), true, true, false,
                    location.jsonIntegracao && (location.jsonIntegracao.integracaoInclusaoSiteInstitucional ||
                        location.jsonIntegracao.integracaoInclusaoCaptacaoLeads) ? false : true, false)

        const usuarioClienteSelecionadoAtivo = ativo

        cliente.current.idFormList = idFormList ? idFormList : HARDCODE.idFormListDefault

        cliente.current.versoesInfoclient = null

        inicializaControleVersao(cliente.current, true)

        let perfilAux
        let tipoLicencaAux
        let fullWhiteLabelAux

        if (AuthService.obterUsuarioLogado(variaveisGlobais) !== ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais)) {

            const configuracaoUsuarioLogado = await getConfiguracaoUsuario(variaveisGlobais,
                AuthService.obterUsuarioLogado(variaveisGlobais), true, true, false, true, false)

            jsonUsuario = configuracaoUsuarioLogado.jsonUsuario
            
            perfilAux = configuracaoUsuarioLogado.perfil
            tipoLicencaAux = configuracaoUsuarioLogado.tipoLicenca
            fullWhiteLabelAux = configuracaoUsuarioLogado.fullWhiteLabel

        } else {

            perfilAux = perfil
            tipoLicencaAux = tipoLicenca
            fullWhiteLabelAux = fullWhiteLabel
        }

        const linhaTipoLicencaAux = pesquisaList(tipoLicencaList, tipoLicencaAux)

        cliente.current = inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient(variaveisGlobais, cliente.current, linhaTipoLicencaAux,
            jsonPagina, jsonUsuario, jsonUsuarioAdmin, false)

        atribuibuiInitialValues()

        if (!AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)) {
            
            setVars(
                {
                    equipeList: await obterEquipeList(idConfiguracao),
                    perfil: perfilAux,
                    linhaPerfil: pesquisaList(perfilList, perfilAux),
                    linhaTipoLicenca: linhaTipoLicencaAux,
                    fullWhiteLabel: fullWhiteLabelAux,
                    usuarioClienteSelecionadoAtivo: usuarioClienteSelecionadoAtivo,
                    idConfiguracao: idConfiguracao,
                    jsonConfiguracao: jsonConfiguracao ? jsonConfiguracao : {}, //jsonConfiguracao
                    indexIdWhiteLabel: identificaIndexIdWhiteLabel(jsonConfiguracao, jsonUsuario),
                    jsonPagina: jsonPagina,
                    jsonGestaoPatrimonial: jsonGestaoPatrimonial,
                    jsonUsuario: jsonUsuario,
                    jsonUsuarioAdmin: jsonUsuarioAdmin,
                }
            )

            //if (!pesquisaList(formList, cliente.current.idFormList).radioGroupFormList) {

            //    cliente.current.formListRadioGroup = HARDCODE.formListAprofundamento
            //}

            if (idCliente) {

                obterInfoclient(idCliente, ultimaVersao, jsonComparacaoEstudos, versao, /*perfilAux,*/ linhaTipoLicencaAux,
                    usuarioClienteSelecionadoAtivo, jsonPagina, jsonUsuario, jsonUsuarioAdmin, null)

            } else {

                if (location.jsonInfoclientCopia) {

                    obterInfoclient(null, ultimaVersao, jsonComparacaoEstudos, versao, /*perfilAux,*/ linhaTipoLicencaAux,
                        usuarioClienteSelecionadoAtivo, jsonPagina, jsonUsuario, jsonUsuarioAdmin, location.jsonInfoclientCopia)

                } else {

                    if (location.clienteExemplo) {

                        const clienteExemploInfoclient =
                            await getByIdClienteExemploMandatorio(variaveisGlobais, location.clienteExemplo)

                        obterInfoclient(null, ultimaVersao, jsonComparacaoEstudos, versao, /*perfilAux,*/ linhaTipoLicencaAux,
                            usuarioClienteSelecionadoAtivo, jsonPagina, jsonUsuario, jsonUsuarioAdmin,
                                /*JSON.parse(JSON.stringify(clienteExemplo))*/JSON.parse(clienteExemploInfoclient.jsonInfoclient))

                    } else {

                        cliente.current.formListRadioGroup =
                            calculaFormListRadioGroup(cliente.current.formListRadioGroup, /*perfilAux,*/ linhaTipoLicencaAux)

                        atribuibuiInitialValues()

                        setCarregou(true)
                    }
                }
            }
        }
    })

    const [tabIndexCliente, setTabIndexCliente] = useState(0)

    

    const handleSubmit = async ( values, isSubmitting ) => {

        const valuesAntAnt = JSON.parse(JSON.stringify(valuesAnt.current))//{...valuesAnt.current}

        valuesAnt.current = JSON.parse(JSON.stringify(objetoCliente(variaveisGlobais, values, null, null)))//{...values}

        const json =
            values.id
                ?
                    await obtemJsonClienteAlteracao(variaveisGlobais, ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                        values.id, values.versao/*ultimaVersao*/, values.jsonComparacaoEstudos)
                : 
                    null

        let status = false

        if (!json || json.id === values.id) {
                
            status = await putClienteInfoclient(variaveisGlobais, null, values, valuesAntAnt, json && json.nomeCliente ? json : null, null)
        }

        if (!status) {
            
            valuesAnt.current = JSON.parse(JSON.stringify(valuesAntAnt))//{...valuesAntAnt}
            
        } else {

            AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)
        }
    }

    const handleSubmitBotaoSalvar = async ( values ) => {

        setSaving(true)

        await handleSubmit(values)

        setSaving(false)
    }

    const handleSubmitAutomatico = async ( values ) => {
        
        //if ({...values} !== {...valuesAnt.current}) {
        //if (!_.isEqual(values, valuesAnt.current)) {
        if (!comparaCliente(values, valuesAnt.current) && !saving) {
            //console.log('vai salvar')
            //console.log(values.cenarios)
            //console.log(valuesAnt.current.cenarios)

            setSaving(true)

            await handleSubmit(values)

            setSaving(false)
        }
    }

    const handleTabChange = ( e, value, values, isSubmitting ) => {

        setTabIndexCliente(value)

        if (values.formListRadioGroup === HARDCODE.formListPrimeiraReuniao) {

            values.tabIndexClientePrimeiraReuniao = value

        } else {

            if (values.formListRadioGroup === HARDCODE.formListAprofundamento) {

                values.tabIndexClienteAprofundamento = value
            }
        }

        handleSubmitAutomatico(values)
    }
    
    

    return (
        carregou
            ?
                <DivFormN0>
                    <DivFormN1>
                        <FormikPadrao
                            initialValues={initialValues}
                            onSubmit={handleSubmit}
                            validateOnChange={false} // implementado para resolver o problema de perfomance da digitação
                            validateOnBlur={false} // implementado para resolver o problema de perfomance da digitação
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setSubmitting,
                                setFieldValue,
                            }) => (
                       
                                <DivForm>
                                    {descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                    linhaFormList, vars.linhaTipoLicenca, vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                    values.jsonAcessoCliente)[tabIndexCliente])
                                    !== LABEL.tabClienteFormListSimulacaoFinanceira && ( // Foi necessário pois não foi achado solução para o LinkPadraoNoSubmit não acionar o Prompt
                                        <Prompt
                                            when={!comparaCliente(values, valuesAnt.current)}
                                            message={MESSAGE().alertaInformacoesNaoSalvas}
                                        />
                                    )}

                                    {!origem && (
                                        <DivFormN1>
                                            <GridContainer
                                                className='mb--1'
                                            >
                                                <GridItem10>
                                                    {!AuthService.obterAcessoCliente(variaveisGlobais) && (
                                                        <BreadcrumbPadrao
                                                            routeSegments={[
                                                                { name: LABEL.pageClienteList, path: PATH.pageClienteList },
                                                                { name: idCliente ? LABEL.pageClienteFormEditarCliente : LABEL.pageClienteFormNovoCliente},
                                                            ]}
                                                        />
                                                    )}
                                                </GridItem10>
                                                
                                                <GridItem2>
                                                    {!AuthService.obterAcessoCliente(variaveisGlobais) &&
                                                    descricaoMenu(tabClienteFormList(
                                                    values.formListRadioGroup, linhaFormList,
                                                    vars.linhaTipoLicenca,
                                                    vars.usuarioClienteSelecionadoAtivo, 
                                                    vars.jsonUsuario,
                                                    values.jsonAcessoCliente)[tabIndexCliente]) !== LABEL.tabClienteFormListSimulacaoFinanceira &&
                                                    descricaoMenu(tabClienteFormList(
                                                    values.formListRadioGroup, linhaFormList,
                                                    vars.linhaTipoLicenca,
                                                    vars.usuarioClienteSelecionadoAtivo, 
                                                    vars.jsonUsuario,
                                                    values.jsonAcessoCliente)[tabIndexCliente]) !== LABEL.tabClienteFormListEstudo &&
                                                    descricaoMenu(tabClienteFormList(
                                                    values.formListRadioGroup, linhaFormList,
                                                    vars.linhaTipoLicenca,
                                                    vars.usuarioClienteSelecionadoAtivo, 
                                                    vars.jsonUsuario,
                                                    values.jsonAcessoCliente)[tabIndexCliente]) !== LABEL.tabClienteFormListRelatorio && (
                                                        <CustomizedDialogsPopup
                                                            maxWidth="xs"
                                                            popupTitle={LABEL.configuracao}
                                                            tooltipTitle={LABEL.configuracao}
                                                            PopupButton={IconButtonConfiguracaoCliente}
                                                            popupButtonDestaque={values.modoInteracaoCliente}
                                                            popupComponent={
                                                                <>
                                                                    <CheckboxPadrao
                                                                        name="modoInteracaoCliente"
                                                                        label={LABEL.modoInteracaoCliente}
                                                                        checked={values.modoInteracaoCliente}
                                                                        onChange={handleChange}
                                                                    />

                                                                    <ButtonReinicializarCenarios
                                                                        confirmacaoText={LABEL.confirmaReinicializacaoCenarios}
                                                                        onClick={() =>
                                                                            reinicializarCenarios(values, vars)
                                                                        }
                                                                    />

                                                                    <CustomizedDialogsPopup
                                                                        maxWidth="xs"
                                                                        popupTitle={LABEL.buttonReordenarCenarios}
                                                                        tooltipTitle={LABEL.buttonReordenarCenarios}
                                                                        PopupButton={ButtonReordenarCenarios}
                                                                        popupComponent={
                                                                            <>
                                                                                {values.cenarios?.map((item, ind) => {
                                                                                        
                                                                                    return (
                                                                                        <GridContainer
                                                                                            key={ind}
                                                                                        >
                                                                                            <GridItem6>
                                                                                                {item.descricao}
                                                                                            </GridItem6>
                                
                                                                                            <GridItem2
                                                                                                align='right'
                                                                                            >
                                                                                                <IconButtonMoveParaCimaParaBaixo
                                                                                                    className='mt-2'
                                                                                                    array={values.cenarios}
                                                                                                    nomeArray={'cenarios'}
                                                                                                    setFieldValue={setFieldValue}
                                                                                                    ind={ind}
                                                                                                />
                                                                                            </GridItem2>
                                                                                        </GridContainer>
                                                                                    )
                                                                                })}
                                                                            </>
                                                                        }
                                                                    />
                                                                </>
                                                            }
                                                        />
                                                    )}
                                                </GridItem2>
                                            </GridContainer>
                                        </DivFormN1>
                                    )}
                                    <ClienteFormCliente
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        valuesAnt={valuesAnt.current}
                                        handleChange={handleChange}
                                        handleSubmit={handleSubmit}
                                        handleSubmitBotaoSalvar={handleSubmitBotaoSalvar}
                                        setFieldValue={setFieldValue}
                                        vars={vars}
                                        linhaFormList={linhaFormList}
                                        setTabIndexClientePrimeiraReuniaoAprofundamento={
                                            setTabIndexClientePrimeiraReuniaoAprofundamento
                                        }
                                        saving={saving}
                                        tabClienteFormList={
                                            descricaoMenu(tabClienteFormList(values.formListRadioGroup, linhaFormList,
                                                vars.linhaTipoLicenca, vars.usuarioClienteSelecionadoAtivo,
                                                    vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                        }
                                        jsonIntegracao={location.jsonIntegracao}
                                    />
                                    {(!location.jsonIntegracao ||
                                    (!location.jsonIntegracao.integracaoInclusaoSiteInstitucional &&
                                    !location.jsonIntegracao.integracaoInclusaoSiteInstitucional2 &&
                                    !location.jsonIntegracao.integracaoInclusaoCaptacaoLeads))
                                    && tabClienteFormList(values.formListRadioGroup, linhaFormList, vars.linhaTipoLicenca,
                                    vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario, values.jsonAcessoCliente).length > 1 && (
                                        <TabsPadrao
                                            value={tabIndexCliente}
                                            onChange={(e, value) => {
                                                handleTabChange (e, value, values)
                                            }}
                                            level={1}
                                        >
                                            {tabClienteFormList(values.formListRadioGroup, linhaFormList, vars.linhaTipoLicenca,
                                            vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                            values.jsonAcessoCliente)?.map((item, ind) => (
                                                <TabPadrao
                                                    value={ind}
                                                    label={item}
                                                    key={ind}
                                                    level={1}
                                                />
                                            ))}
                                        </TabsPadrao>
                                    )}
                                   
                                    {location.jsonIntegracao &&
                                    (location.jsonIntegracao.integracaoInclusaoSiteInstitucional ||
                                    location.jsonIntegracao.integracaoInclusaoSiteInstitucional2 ||
                                    location.jsonIntegracao.integracaoInclusaoCaptacaoLeads)
                                        ?
                                            location.jsonIntegracao.integracaoInclusaoSiteInstitucional ||
                                            location.jsonIntegracao.integracaoInclusaoCaptacaoLeads
                                                ?
                                                    <CaptacaoLeadsForm
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        vars={vars}
                                                        //linhaTipoLicenca={vars.linhaTipoLicenca}
                                                        //idConfiguracao={vars.idConfiguracao}
                                                        //jsonConfiguracao={vars.jsonConfiguracao}
                                                        //jsonUsuario={vars.jsonUsuario}
                                                        //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                                        linhaFormList={linhaFormList}
                                                        jsonIntegracao={location.jsonIntegracao}
                                                        arquivoList={arquivoList}
                                                        obterArquivoList={obterArquivoList}
                                                    />
                                                :
                                                    <FormForm
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        vars={vars}
                                                        jsonIntegracao={location.jsonIntegracao}
                                                        arquivoList={arquivoList}
                                                        obterArquivoList={obterArquivoList}
                                                    />
                                        :
                                            descricaoMenu(tabClienteFormList(values.formListRadioGroup, linhaFormList,
                                            vars.linhaTipoLicenca, vars.usuarioClienteSelecionadoAtivo,
                                            vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                            === LABEL.tabClienteFormListCadastro
                                                ?
                                                    <CadastroForm
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        vars={vars}
                                                        arquivoList={arquivoList}
                                                        obterArquivoList={obterArquivoList}
                                                    />
                                                :
                                                    descricaoMenu(tabClienteFormList(values.formListRadioGroup, linhaFormList,
                                                    vars.linhaTipoLicenca, vars.usuarioClienteSelecionadoAtivo,
                                                    vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                    === LABEL.tabClienteFormListDadosBasicos
                                                        ?
                                                            values.formListRadioGroup === HARDCODE.formListPrimeiraReuniao
                                                                ?
                                                                    <FormForm
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        handleSubmit={handleSubmit}
                                                                        setFieldValue={setFieldValue}
                                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                                        vars={vars}
                                                                        arquivoList={arquivoList}
                                                                        obterArquivoList={obterArquivoList}
                                                                    />
                                                                :
                                                                    // Necessário para forçar a execução do useSingleton + setTabIndexForm
                                                                    <>
                                                                        <FormForm
                                                                            variaveisGlobais={variaveisGlobais}
                                                                            values={values}
                                                                            handleChange={handleChange}
                                                                            handleSubmit={handleSubmit}
                                                                            setFieldValue={setFieldValue}
                                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                                            vars={vars}
                                                                            arquivoList={arquivoList}
                                                                            obterArquivoList={obterArquivoList}
                                                                        />
                                                                    </>
                                                    :
                                                        <>
                                                            {(!dadosCompletosCliente(values, vars.jsonConfiguracao, true) ||
                                                            (values.idadeCliente && values.idadeCliente > 500) ||
                                                            (values.idadeConjuge && values.idadeConjuge > 500)) &&
                                                            descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                            linhaFormList, vars.linhaTipoLicenca, vars.usuarioClienteSelecionadoAtivo,
                                                            vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                            !== LABEL.tabClienteFormListPrevidenciaPrivada
                                                                ?
                                                                    <MensagemDadosObrigatoriosClienteDevemSerInformados
                                                                        vars={vars}
                                                                    />
                                                                :
                                                                    <>
                                                                        {descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListFluxoCaixa && (
                                                                                <FluxoCaixaForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                                                                    jsonConfiguracao={vars.jsonConfiguracao}
                                                                                />
                                                                        )}
                                                                        {descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListPatrimonio && (
                                                                                <PatrimonioForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    equipeList={vars.equipeList}
                                                                                    setFieldValue={setFieldValue}
                                                                                    vars={vars}
                                                                                    arquivoList={arquivoList}
                                                                                />
                                                                        )}
                                                                        {(descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListSimulacaoFinanceira ||
                                                                        (descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo, 
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListRelatorio &&
                                                                        values.formListRadioGroup === HARDCODE.formListPrimeiraReuniao &&
                                                                        !values.jsonAcessoCliente.disponibilizarRelatorioEstudo)
                                                                        ) && (
                                                                                <SimulacaoFinanceiraFormMenu
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                    vars={vars}
                                                                                    linhaFormList={linhaFormList}
                                                                                    tabClienteFormList={
                                                                                        descricaoMenu(tabClienteFormList(
                                                                                        values.formListRadioGroup, linhaFormList,
                                                                                        vars.linhaTipoLicenca,
                                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                                        vars.jsonUsuario,
                                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                                    }
                                                                                />
                                                                        )}
                                                                        {(descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListEstudo ||
                                                                        descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListPrevidenciaPrivada) && (
                                                                                <EstudoForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                    vars={vars}
                                                                                    linhaFormList={linhaFormList}
                                                                                    tabClienteFormList={
                                                                                        descricaoMenu(tabClienteFormList(
                                                                                        values.formListRadioGroup, linhaFormList,
                                                                                        vars.linhaTipoLicenca,
                                                                                        vars.usuarioClienteSelecionadoAtivo, 
                                                                                        vars.jsonUsuario,
                                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                                    }
                                                                                    arquivoList={arquivoList}
                                                                                    obterArquivoList={obterArquivoList}
                                                                                />
                                                                        )}
                                                                        {(descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListRelatorio &&
                                                                        (values.formListRadioGroup === HARDCODE.formListAprofundamento ||
                                                                        values.jsonAcessoCliente.disponibilizarRelatorioEstudo
                                                                        )) && (
                                                                                // Necessário para forçar o recálculo das variáveis de controle do menu
                                                                                <EstudoForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                    vars={vars}
                                                                                    linhaFormList={linhaFormList}
                                                                                    tabClienteFormList={
                                                                                        descricaoMenu(tabClienteFormList(
                                                                                        values.formListRadioGroup, linhaFormList,
                                                                                        vars.linhaTipoLicenca,
                                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                                        vars.jsonUsuario,
                                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                                    }
                                                                                    arquivoList={arquivoList}
                                                                                    obterArquivoList={obterArquivoList}
                                                                                />
                                                                        )}
                                                                        {(descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo, vars.jsonUsuario,
                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL.tabClienteFormListGestaoPatrimonial) && (
                                                                                // Necessário para forçar o recálculo das variáveis de controle do menu
                                                                                <EstudoForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                    vars={vars}
                                                                                    linhaFormList={linhaFormList}
                                                                                    tabClienteFormList={
                                                                                        descricaoMenu(tabClienteFormList(
                                                                                        values.formListRadioGroup, linhaFormList,
                                                                                        vars.linhaTipoLicenca,
                                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                                        vars.jsonUsuario,
                                                                                        values.jsonAcessoCliente)[tabIndexCliente])
                                                                                    }
                                                                                    arquivoList={arquivoList}
                                                                                    obterArquivoList={obterArquivoList}
                                                                                />
                                                                        )}
                                                                        {descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo,
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === linhaFormList.labelTabClienteFormListConsideracoesFinais && (
                                                                                <ConsideracoesFinaisForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    vars={vars}
                                                                                    linhaFormList={linhaFormList}
                                                                                />
                                                                        )}
                                                                        {descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca,
                                                                        vars.usuarioClienteSelecionadoAtivo, 
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        ===LABEL.tabClienteFormListAcompanhamento && (
                                                                                <AcompanhamentoForm
                                                                                    variaveisGlobais={variaveisGlobais}
                                                                                    values={values}
                                                                                    handleChange={handleChange}
                                                                                    handleSubmit={handleSubmit}
                                                                                    setFieldValue={setFieldValue}
                                                                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                                                                    vars={vars}
                                                                                    arquivoList={arquivoList}
                                                                                    obterArquivoList={obterArquivoList}
                                                                                />
                                                                        )}
                                                                        {/*
                                                                        {descricaoMenu(tabClienteFormList(values.formListRadioGroup,
                                                                        linhaFormList, vars.linhaTipoLicenca, vars.usuarioClienteSelecionadoAtivo,
                                                                        vars.jsonUsuario, values.jsonAcessoCliente)[tabIndexCliente])
                                                                        === LABEL. && (
                                                                            <LogAcessoClienteForm />
                                                                        )}
                                                                        */}
                                                                    </>
                                                            }
                                                        </>
                                    }
                                </DivForm>
                            )}
                        </FormikPadrao>
                        {saving && (
                            <CircularProgressPadrao />
                        )}
                    </DivFormN1>
                </DivFormN0>
            :
                ''
    )
}

export default ClienteForm